module.exports = __webpack_public_path__ + "img/nc.c279594.svg";